import { Component, Inject } from '@angular/core';
import { CalibrationBalanceEssayAsFound, CalibrationBalanceVariable } from '../../../../model/calibrationBalance';
import { firstValueFrom } from 'rxjs';
import { NumberUtils } from '../../../../utils/numberUtils';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { VariableTypeService } from '../../../../services/variableType.service';
import { TranslateService } from '@ngx-translate/core';
import { SnackBarService } from '../../../../services/snackBar.service';
import { SpinnerService } from '../../../../services/spinner.service';
import { CalibrationBalanceUtils } from '../../../../utils/calibrationBalanceUtils';
import { VariableUnitEnum } from '../../../../model/variable';

export interface DialogDataCalibrationAsFound {
  item: CalibrationBalanceEssayAsFound;
  variable: CalibrationBalanceVariable;
}

@Component({
  selector: 'app-calibration-balance-edit-as-found-dialog',
  templateUrl: './calibration-balance-edit-as-found-dialog.component.html',
  styleUrl: './calibration-balance-edit-as-found-dialog.component.scss',
  standalone: false
})
export class CalibrationBalanceEditAsFoundDialogComponent {
  radius: number = null;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: DialogDataCalibrationAsFound,
    public dialogRef: MatDialogRef<CalibrationBalanceEditAsFoundDialogComponent>,
    private variableTypeService: VariableTypeService,
    private translate: TranslateService,
    public snackBarService: SnackBarService,
    private spinnerService: SpinnerService) {

    if (this.showExtraField()) {
      this.spinnerService.show();

      this.variableTypeService.convert(this.data.variable.extraField, this.data.variable.idUnitExtra, VariableUnitEnum.LENGHT_M)
        .subscribe((res: number) => {
          this.radius = res;
          this.spinnerService.hide();
        });
    }

  }

  onOkClick(): void {

    const errs = [];

    if (this.data.item.point == null) {
      errs.push(this.translate.instant('calibrateEquipmentEdit.asFound.dialog.point.error'));
    }

    if (this.data.item.pattern == null || isNaN(+this.data.item.pattern)) {
      errs.push(this.translate.instant('calibrateEquipmentEdit.asFound.dialog.pattern.error'));
    }

    if (this.data.item.equipment == null) {
      errs.push(this.translate.instant('calibrateEquipmentEdit.asFound.dialog.equipment.error'));
    }

    if (this.data.item.pattern && this.data.item.equipment) {
      if (NumberUtils.countDecimalsAny(this.data.item.pattern) != NumberUtils.countDecimalsAny(this.data.item.equipment)) {
       if (NumberUtils.countDecimalsAny(this.data.item.equipment) > NumberUtils.countDecimalsAny(this.data.item.pattern)) { 
        errs.push(this.translate.instant('calibrateEquipmentEdit.asFound.dialog.lengthPatternEqupiment.error'));
       }
      }
    }

    if (errs.length === 0) {
      this.dialogRef.close(this.data.item);
    } else {
      const error = errs.join('\n');
      this.snackBarService.sendError(error);
    }

  }

  async onChangeValue(value: number): Promise<void> {
    this.data.item.equipment = value;

    if (this.radius != null) {
      const idUnitFrom = this.data.variable.idUnitInput;
      const idUnitTo = this.data.variable.idUnit;
      this.data.item.equipmentOriginal = NumberUtils.fixPrecision(await firstValueFrom(
        this.variableTypeService.convertWithRadius(this.data.item.equipment, this.radius, idUnitFrom, idUnitTo)) as number);
    }
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  showExtraField(variable: CalibrationBalanceVariable = this.data.variable): boolean {
    return CalibrationBalanceUtils.showExtraField(variable);
  }

  getExtraFieldName(variable: CalibrationBalanceVariable = this.data.variable): string {
    return CalibrationBalanceUtils.getExtraFieldName(variable);
  }

}
